import { render, staticRenderFns } from "./OverallTable.vue?vue&type=template&id=2a193406&"
import script from "./OverallTable.vue?vue&type=script&lang=js&"
export * from "./OverallTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports